import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginComponent } from "./modules/authentication/login/login.component";
import { AuthGuard } from "./core/guards/auth.guard";
import { AppComponent } from "./app.component";
import { PageNotFoundComponent } from "./modules/authentication/page-not-found/page-not-found.component";
import { NoAuthGuard } from "./core/guards/no-auth.guard";
import { AfterLoginGuard } from "./core/guards/after-login.guard";
import { ViewComponent } from "./modules/view/view.component";
import { ResetPasswordComponent } from "./modules/authentication/reset-password/reset-password.component";

const appRoutes: Routes = [
  { path: "login", component: LoginComponent, canActivate: [AfterLoginGuard] },
  { path: "reset-password", component: ResetPasswordComponent },
  { path: "view", component: ViewComponent, canActivate: [AuthGuard] },

  // {
  //   path: 'campus',
  //   component: AppComponent,
  //   loadChildren: './modules/campus/campus.module#CampusModule',
  //   canActivate: [AuthGuard]
  // },
  // {
  //   path: 'user',
  //   component: AppComponent,
  //   loadChildren: './modules/user/user.module#UserModule',
  //   canActivate: [AuthGuard]
  // },
  // // {
  //   path: 'view',
  //   component: AppComponent,
  //   loadChildren: './modules/view',
  //   canActivate: [AuthGuard]
  // },
  { path: "", redirectTo: "login", pathMatch: "full" },
  { path: "404", component: PageNotFoundComponent, pathMatch: "full" },
  { path: "**", redirectTo: "", pathMatch: "full" },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { useHash: true })],
  exports: [RouterModule],
  providers: [AuthGuard],
})
export class AppRoutingModule {}
